import React from "react";
import {
    Heading,
    ListItem,
    List,
    Text
} from "spectacle";
import Button from '../components/Button';

const KnownUnknowns = () =>
    <div>
        <Heading size={6} textColor="secondary" caps bold>
            KNOWN UNKNOWNS
        </Heading>
        <Text textSize={30} textColor="primary">
            Key datapoints sales organizations are missing
        </Text>
        <List ordered textColor="secondary" style={{ paddingLeft: '25px', listStylePosition: 'outside' }}>
            <ListItem textSize={25}>Following up is often a send and forget mentality</ListItem>
            <ListItem textSize={25}>As sellers are racing to get leads and gain audience with prospects, follow-ups often lack a personal and curated feel.  This leaves the next engagement to chance.</ListItem>
            <ListItem textSize={25}>Any attachments with the follow up are not trackable leaving zero intelligence indicating interest or engagement</ListItem>
        </List>
    </div>

export default KnownUnknowns;


// WEBPACK FOOTER //
// ./src/slides/KnownUnknowns.js